export const ADD_POS_TERMINAL = "ADD_POS_TERMINAL"
export const EDIT_POS_TERMINAL = "EDIT_POS_TERMINAL"
export const DELETE_POS_TERMINAL = "DELETE_POS_TERMINAL"